import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class ColorModel extends BaseModel {

    constructor() {
        super({
                name: "color",
                tableName: 'color',
                label: "Color",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    display: false
                },
            })
    }

}